/** OnlyFans statistics periods, in the UTC form its endpoints take. */
const DAY_MS = 86_400_000

/** OnlyFans' UTC query time, "YYYY-MM-DD HH:mm:ss". */
export function ofUtc(date: Date): string {
  const p = (n: number) => String(n).padStart(2, '0')
  return `${date.getUTCFullYear()}-${p(date.getUTCMonth() + 1)}-${p(date.getUTCDate())} ${p(date.getUTCHours())}:${p(date.getUTCMinutes())}:${p(date.getUTCSeconds())}`
}

/** "Last 30 days" as OnlyFans asks for it. */
export function last30Days(now: Date): { startDate: string; endDate: string } {
  return { startDate: `${ofUtc(new Date(now.getTime() - 30 * DAY_MS)).slice(0, 10)} 00:00:00`, endDate: ofUtc(now) }
}
